
import { Dialog } from '@mui/material';
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { IoClose } from 'react-icons/io5';

const PaymentModal = ({ displayModal, setDisplayModal }) => {
    const { t } = useTranslation('paymentModal');
    const handleclose = () => {
        localStorage.setItem("addGuestModal", true);
        setDisplayModal(false);
    }
    useEffect(() => {
        const returnmodal = localStorage.getItem("addGuestModal");
        setDisplayModal(!returnmodal);
    }, [])
    return (
        <>
            {
                displayModal && (
                    <Dialog
                        open={displayModal}
                        onClose={handleclose}
                        PaperProps={{
                            sx: {
                                borderRadius: "20px",
                                width: "630px",

                            },
                        }}
                    >
                        <div className="bg-white p-6  flex flex-col gap-3 rounded-[20px]">
                            <div className="gap-1">
                                <div className="flex  items-start justify-between w-full ">
                                    <span className='text-[18px] font-[600] text-[#131415] '>{t("title")}</span>
                                    <span onClick={handleclose}><IoClose /></span>
                                </div>
                                <p className='text-[15px] text-[#535861]'>{t("message")}</p>
                            </div>

                            <div className='flex flex-col  gap-1 text-[15px] items-start'>
                                <span className='font-[600] text-[#131415] text-[16px]'> {t("nextStep.title")}</span>
                                <p className='text-[#535861] flex items-center '>{t("nextStep.message")}</p>
                            </div>
                            <button className='bg-[#3686FF] text-white rounded-lg  h-[32px]  w-full max-w-32 my-1  text-[14px] text-center' >{t("downloadQrButton")}</button>
                            <div className="div">
                                <p className='font-[500] text-[#131415] text-[15px]'>{t("bestRegards")}</p>
                                <p className='font-[500] text-[#131415] text-[15px]'>{t("teamName")}</p>
                            </div>
                        </div>
                    </Dialog >
                )
            }
        </>
    )
}

export default PaymentModal